import { GROUP_MODAL_VISIBILITY,
        TOGGLE_GROUP_MODAL_VISIBILITY, 
        CREATE_GROUP_SUCCESS, 
        EDIT_GROUP_SUCCESS, 
        DELETE_GROUP_SUCCESS,
        GROUP_PROCESS_FAIL } from './actionTypes'
import { apiStart, apiComplete, apiFail } from "./common";
import { axiosInstance2 } from "../../utils/axiosConfig";
// import _ from 'lodash';

const CONTENT_JSON_HEADER = {
    "Content-Type": "application/json"
}

export const callGroupingModal = (modalType, modalCallType, groupReferenceId, userGroupReferenceId, indexName, indexValType) => {
// export const callHotelGroupModal = (modalCallType,groupReferenceId,userGroupReferenceId) => {
    return {
        type : GROUP_MODAL_VISIBILITY,
        groupingModalData : {
            modalType: modalType,
            groupingAction : modalCallType,
            groupId : groupReferenceId,
            userGroupId : userGroupReferenceId,
            indexName: indexName,
            indexValueType: indexValType,
        }
    }
}

export const toggleGroupModalVisibility = () => {
    return {
        type: TOGGLE_GROUP_MODAL_VISIBILITY
    }
}

export const createGroup = (params) => {
// export const createHotelGroup = (params) => {
    return async dispatch => {
        let message = '';
        let data = [];
        // dispatch(apiStart());
        await axiosInstance2.post('/api/callExternal/createUserHotelGroup',
            params,
            CONTENT_JSON_HEADER
        )
        .then(response => {
            if (response["data"]["error"]) {
                message = response["data"]["message"]
                console.error("ERROR :", message);
                dispatch({
                    type: GROUP_PROCESS_FAIL,
                    triggerType: 'CREATE',
                    triggerData: {
                        "message": message,
                        "data" : data
                    }
                })
            } else {
                message = "Hotel group created successfully"
                data = response["data"]["data"];
                // dispatch(apiComplete());
                dispatch({
                    type: CREATE_GROUP_SUCCESS,
                    triggerType: 'CREATE',
                    triggerData: {
                        "message": message,
                        "data" : data
                    }
                })

            }
        }).catch(err => {
            message = err;
            console.error("ERROR :", message);
            dispatch({
                type: GROUP_PROCESS_FAIL,
                triggerType: 'CREATE',
                triggerData: {
                    "message": message,
                    "data" : data
                }
            })
            
        })
    }
}

export const editGroup = (params) => {
// export const editHotelGroup = (params) => {
    return async dispatch => {
        let message = '';
        let data = {};
        // dispatch(apiStart());
        await axiosInstance2.post('/api/callExternal/updateUserHotelGroup',
            params,
            CONTENT_JSON_HEADER
        )
        .then(response => {
            if (response["data"]["error"]) {
                message = response["data"]["message"]
                console.error("ERROR :", message);
                dispatch({
                    type: GROUP_PROCESS_FAIL,
                    triggerType: 'EDIT',
                    triggerData: {
                        "message": message,
                        "data" : data
                    }
                })
            } else {
                message = "Hotel group updated successfully"
                data = response["data"]["data"];
                dispatch({
                    type: EDIT_GROUP_SUCCESS,
                    triggerType: 'EDIT',
                    triggerData: {
                        "message": message,
                        "data" : data
                    }
                })

            }
        }).catch(err => {
            message = err;
            console.error("ERROR :", message);
            dispatch({
                type: GROUP_PROCESS_FAIL,
                triggerType: 'EDIT',
                triggerData: {
                    "message": message,
                    "data" : data
                }
            })
        })
    }
}
    
export const deleteGroup = (params) => {
// export const deleteHotelGroup = (params) => {
    return async dispatch => {
        let message = '';
        let data = {};
        // dispatch(apiStart());
        await axiosInstance2.post('/api/callExternal/deleteUserHotelGroup',
            params,
            CONTENT_JSON_HEADER
        )
        .then(response => {
            console.log(response, "response...")
            if (response["data"]["error"]) {
                message = response["data"]["message"]
                console.error("ERROR :", message);
                dispatch({
                    type: GROUP_PROCESS_FAIL,
                    triggerType: 'DELETE',
                    triggerData: {
                        "message": message,
                        "data" : data
                    }
                })
            } else {
                message = "Hotel group deleted successfully"
                data = response["data"]["data"];
                dispatch({
                    type: DELETE_GROUP_SUCCESS,
                    triggerType: 'DELETE',
                    triggerData: {
                        "message": message,
                        "data" : data
                    }
                })

            }
        }).catch(err => {
            message = err;
            console.error("ERROR :", message);
            dispatch({
                type: GROUP_PROCESS_FAIL,
                triggerType: 'DELETE',
                triggerData: {
                    "message": message,
                    "data" : data
                }
            })
        })
    }
}
